import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell, AuthShell, RedirectIfSignedIn, RequireAuth } from '@srichaitra/common';
import { labels, routes } from '@srichaitra/constants';
import { LoginPage } from '../pages/LoginPage';
import { DashboardPage } from '../pages/DashboardPage';
import { NotFoundPage } from '../pages/NotFoundPage';

/**
 * The application's routes.
 *
 * Two nested groups, each with a guard on the outside and a container on the
 * inside:
 *
 *   RedirectIfSignedIn → AuthShell  → the signed-out pages
 *   RequireAuth        → AppShell   → everything else
 *
 * Because the container is a layout route, every page inside it renders through
 * its <Outlet />. Adding a screen is a single <Route> here — it inherits the
 * header, navigation, notifications and guard without knowing they exist.
 */

/** The links in the shell's navigation bar. */
const NAV_ITEMS = [{ to: routes.dashboard, label: labels.nav.dashboard }];

export function App() {
  return (
    <Routes>
      <Route element={<RedirectIfSignedIn />}>
        <Route element={<AuthShell />}>
          <Route path={routes.login} element={<LoginPage />} />
        </Route>
      </Route>

      <Route element={<RequireAuth />}>
        <Route element={<AppShell navItems={NAV_ITEMS} />}>
          <Route path={routes.dashboard} element={<DashboardPage />} />
          {/* Inside the guard on purpose: an unknown URL from a signed-out
              visitor should send them to sign in, not tell them the page is
              missing. */}
          <Route path={routes.notFound} element={<NotFoundPage />} />
        </Route>
      </Route>

      <Route path={routes.root} element={<Navigate to={routes.dashboard} replace />} />
    </Routes>
  );
}

export default App;
